import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NavBoxes extends Component {
  constructor(props) {
      super(props);
      this.state = {
        currentPage: props.location.pathname
      };

  }

  componentWillReceiveProps(nextProps) {
    if( nextProps.location.pathname !== this.state.currentPage) {
      this.setState({
        currentPage : nextProps.location.pathname
      });
    }
  }
  getNavBoxes() {
    let attendance = this.state.currentPage === "/" ? '' : '_grey';
    let ncaa = this.state.currentPage === "/ncaa" ? '' : '_grey';
    let ncaachamps = this.state.currentPage === "/ncaachamps" ? '' : '_grey';
    let nationalteams = this.state.currentPage === "/nationalteams" ? '' : '_grey';
    let teamsmap = this.state.currentPage === "/teamsmap" ? '' : '_grey';
    let coachespoll = this.state.currentPage === "/coachespoll" ? '' : '_grey';
    let allteams = this.state.currentPage === "/allteams" ? '' : '_grey';

    return <div className="small-12 columns">
      <Link className={"navbox nav-attendance"+attendance} to="/"></Link>
      <Link className={"navbox nav-ncaa"+ncaa} to="/ncaa"></Link>
      <Link className={"navbox nav-ncaachamps"+ncaachamps} to="/ncaachamps"></Link>
      <Link className={"navbox nav-nationalteams"+nationalteams} to="/nationalteams"></Link>
      <Link className={"navbox nav-teamsmap"+teamsmap} to="/teamsmap"></Link>
      <Link className={"navbox nav-coachespoll"+coachespoll} to="/coachespoll"></Link>
      <Link className={"navbox nav-allteams"+allteams} to="/allteams"></Link>
    </div>;
  }
  render() {
    return (
      <div className="row expanded">
        {this.getNavBoxes()}
        <div className="clearboth"></div>
      </div>
    );
  }
}

export default NavBoxes;



// WEBPACK FOOTER //
// ./src/components/nav/NavBoxes.js